var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon_awesome-facebook-f","data-name":"Icon awesome-facebook-f","d":"M13.841,13.747l.679-4.423H10.276V6.454a2.212,2.212,0,0,1,2.494-2.39H14.7V.3A23.528,23.528,0,0,0,11.274,0c-3.5,0-5.78,2.118-5.78,5.953V9.324H1.609v4.423H5.494V24.439h4.781V13.747Z","transform":"translate(-1.609)","fill":"#fff"}));
}

FacebookIcon.defaultProps = {"width":"13.089","height":"24.439","viewBox":"0 0 13.089 24.439"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
